"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_linear_gradient_1 = __importDefault(require("react-native-linear-gradient"));
const scale_1 = require("../../utils/scale");
const CustomText_1 = __importDefault(require("../text/CustomText"));
const BUTTON_COLORS = {
    default: ['#00AEEF', '#287BCF'],
    hover: ['#009CD6', '#236CB5'],
    active: ['#287BCF', '#287BCF'],
    disabled: ['#DDDDDD', '#DDDDDD'],
};
const LinearButton = (props) => {
    const { title, colors, style = {}, containerStyle = {}, textStyle = {}, onPress, fontWeight = '300', disabled = false, children, } = props;
    const [isHovered, setIsHovered] = (0, react_1.useState)(false);
    const [isPressed, setIsPressed] = (0, react_1.useState)(false);
    const getColor = () => {
        if (disabled) {
            return BUTTON_COLORS['disabled'];
        }
        if (isPressed) {
            return BUTTON_COLORS['active'];
        }
        if (isHovered) {
            return BUTTON_COLORS['hover'];
        }
        return BUTTON_COLORS['default'];
    };
    return (react_1.default.createElement(react_native_1.Pressable, { onPress: onPress, disabled: disabled, style: containerStyle, onPressIn: () => setIsPressed(true), onPressOut: () => setIsPressed(false), onHoverIn: () => setIsHovered(true), onHoverOut: () => setIsHovered(false) },
        react_1.default.createElement(react_native_linear_gradient_1.default, { colors: colors || getColor(), style: [styles.button, style], start: { x: 0, y: 0 }, end: { x: 1, y: 1 } }, children ? (children) : (react_1.default.createElement(CustomText_1.default, { weight: fontWeight, style: [styles.text, textStyle, disabled && { color: '#999999' }] }, title)))));
};
exports.default = LinearButton;
const styles = react_native_1.StyleSheet.create({
    button: {
        justifyContent: 'center',
        alignItems: 'center',
        height: (0, scale_1.scale)(48),
        width: '100%',
        borderRadius: (0, scale_1.scale)(4),
    },
    text: {
        fontSize: (0, scale_1.moderateScale)(16),
        lineHeight: (0, scale_1.moderateScale)(24),
        color: '#FEFEFE',
    },
});
